import ShareIconDark from 'assets/images/icons/dark - share.svg?react';
import ShareIconSimpleFiligree from 'assets/images/icons/simple filigree - share.svg?react';
import ShareIconSpringVibes from 'assets/images/icons/spring - share.svg?react';
import ShareIconVickyBaumannBoho from 'assets/images/icons/vicky boho - share.svg?react';
import ShareIconVickyBaumannFineart from 'assets/images/icons/vicky fineart - share.svg?react';
import { IIconProps } from 'types/icons';
import { BaseIcon } from './BaseIcon';
import { SetIcon } from './SetIcon';
import { useTemplateVariant } from 'hooks/useTemplateVariant';

const LegacyShareIcon = (props: IIconProps) =>
  useTemplateVariant({
    classic: () => <BaseIcon icon={ShareIconSimpleFiligree} {...props} />,
    dark: () => <BaseIcon icon={ShareIconDark} {...props} />,
    simpleFiligree: () => <BaseIcon icon={ShareIconSimpleFiligree} {...props} />,
    springVibes: () => <BaseIcon icon={ShareIconSpringVibes} {...props} />,
    vickyBaumannBoho: () => <BaseIcon icon={ShareIconVickyBaumannBoho} {...props} />,
    vickyBaumannFineart: () => <BaseIcon icon={ShareIconVickyBaumannFineart} {...props} />,
    breeze: () => <BaseIcon icon={ShareIconSimpleFiligree} {...props} />,
    capri: () => <BaseIcon icon={ShareIconSimpleFiligree} {...props} />,
    rose: () => <BaseIcon icon={ShareIconSimpleFiligree} {...props} />,
    calm: () => <BaseIcon icon={ShareIconSimpleFiligree} {...props} />
  })();

export const ShareIcon = (props: IIconProps) => (
  <SetIcon slug="share" fallback={LegacyShareIcon} {...props} />
);
